import React, { useState, useEffect } from "react";
import "../CI/COD.css";
import { getRequest, postRequest } from "../../globalhelper/helper";
import GetAppIcon from "@material-ui/icons/GetApp";
import { useDispatch, useSelector } from "react-redux";
import VR2_Forms from "../../pages/VR2_Form_Rendering/displayContainer";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import { hideLoader, showLoader } from "../../redux/Common/commonActions";
import { CSVLink } from "react-csv";
import moment from "moment/moment";

const Approval = () => {
  const [formData, setFormData] = useState({
    task: "",
    orgname: "",
  });
  const [searchFormData, setSearchFormData] = useState({
    documentID: "",
    documentName: "",
    documentType: "",
    documentActivityCode: "",
  });
  const [tableData, setTableData] = useState([]);
  const [activityCode, setActivityCode] = useState("");
  const [showtable, setShowtable] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [dropdown_id, setDropdown_id] = useState([]);
  const [dropdown_number, setDropdown_number] = useState([]);
  const [dropdown_type, setDropdown_type] = useState([]);
  const [dropdown_activitycode, setDropdown_activitycode] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [dropdown_orgname, setDropdown_orgname] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [redirectVM, setRedirectVM] = useState(false);
  const [redirectPO, setRedirectPO] = useState(false);
  const [redirectIM, setRedirectIM] = useState(false);
  const [redirectIP, setRedirectIP] = useState(false);
  const [redirectOM, setRedirectOM] = useState(false);
  const [redirectBE, setRedirectBE] = useState(false);
  const [redirectGS, setRedirectGS] = useState(false);
  const [redirectVP, setRedirectVP] = useState(false);
  const [redirectItemPre, setRedirectItemPre] = useState(false);
  const [redirectBudgetRelease, setRedirectBudgetRelease] = useState(false);
  const [SearchJSON, setSearchJSON] = useState([]);
  let dispatch = useDispatch();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setPage(0); // Reset to first page when data changes
  }, [filterData]);

  useEffect(() => {
    sessionStorage.setItem("pageName", "Approval");
    setFetching(true);

    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then((response) => {
        const responseData = response.res.data;
        const arr = responseData.map((item) => item.orgname);
        setDropdown_orgname(arr);
        setCompanyDetails(responseData);
        if (arr?.length === 1) {
          handleCompanyChange(arr[0]);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (formData.task !== "" && formData.task !== null) {
      setSearchFormData({
        documentID: "",
        documentName: "",
        documentType: "",
        documentActivityCode: "",
      });
      dispatch(showLoader());
      getRequest(`api/edureka/getVendorActivityCode`)
        .then((res) => {
          console.log(res.res.data);
          setFetching(false);
          setActivityCode(res.res.data);
          handleSearch(formData.task);
        })
        .catch((err) => {
          dispatch(hideLoader());
          console.log(err);
        });
    }
  }, [formData.task]);

  const handleChange = (val) => {
    setFormData((prev) => ({
      ...prev,
      task: val,
    }));
  };

  const handleSearch = (val) => {
    if (formData.orgname && val !== null) {
      const id = companyDetails.filter(
        (item) => item.orgname === formData.orgname
      );
      const companyid = id.map((item) => item.orgid);
      setFetching(true);
      setLoading(true);
      setShowtable(false);

      getRequest(
        `api/edureka/getVendorApproval?status=${val}&orgid=${companyid[0]}`
      )
        .then((res) => {
          const value = res.res.data;

          const tempArrID = value.map((obj) => obj["Vendor ID"]);
          const filtedID = [...new Set(tempArrID)]
            .map((obj) => obj ?? null)
            .filter((name) => name && name.trim() !== "");
          const tempArrName = value.map((obj) => obj["Vendor Name"]);
          const tempArrType = value.map((obj) => obj["Type"]);
          const filtedType = [...new Set(tempArrType)]
            .map((obj) => obj ?? null)
            .filter((name) => name && name.trim() !== "");
          const filteredName = [...new Set(tempArrName)];
          const finalName = filteredName
            .map((obj) => obj ?? null)
            .filter((name) => name && name.trim() !== "");
          const tempActivityCode = value.map((obj) => obj["activitycode"]);
          const filtedActivitycode = [...new Set(tempActivityCode)]
            .map((obj) => obj ?? null)
            .filter((name) => name && name.trim() !== "");

          setTableData(res.res.data);
          setFilterData(res.res.data);
          setDropdown_id(filtedID);
          setDropdown_number(finalName);
          setDropdown_type(filtedType);
          setDropdown_activitycode(filtedActivitycode);
          setShowtable(true);
          setFetching(false);
          setLoading(false);
        })
        .finally(() => {
          dispatch(hideLoader());
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getTimeAgeing = (item) => {
    const providedDateTime = item;
    const providedDate = new Date(providedDateTime);
    const currentDate = new Date();
    const timeDifference = currentDate - providedDate;

    const millisecondsInOneSecond = 1000;
    const millisecondsInOneMinute = 60 * millisecondsInOneSecond;
    const millisecondsInOneHour = 60 * millisecondsInOneMinute;
    const millisecondsInOneDay = 24 * millisecondsInOneHour;

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    );

    return `${days}D, ${hours}H, ${minutes}M`;
  };

  const handleID = (i) => {
    console.log(i);
    console.log(activityCode);
    const id = i["Vendor ID"];
    const lde = i["organizationid"];
    console.log(id);
    console.log(id.substring(0, 2));

    if (id.substring(0, 2) === "VM" && lde === "NoLDE") {
      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${"VendorMaster"}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      );
      window.open(
        `/Dynamic_Forms?token=VendorMaster&action=approval&orgId=${lde}&docId=${id}`,
        "_blank"
      );
      // postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${'VendorMaster'}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      // ).then(response => {
      //   if (response.res.status === 'success') {
      //     console.log(response.res.data)
      //     setSearchJSON(response.res.data)
      //     setRedirectVM(true)
      //   } else {
      //     console.log('No Data')
      //   }
      // })
    } else if (id.substring(0, 2) === "PO") {
      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${"PurchaseOrder"}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      );
      window.open(
        `/Dynamic_Forms?token=PurchaseOrder&action=approval&orgId=${lde}&docId=${id}`,
        "_blank"
      );
      // postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${'PurchaseOrder'}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      // ).then(response => {
      //   if (response.res.status === 'success') {
      //     console.log(response.res.data)
      //     setSearchJSON(response.res.data)
      //     setRedirectPO(true)
      //   } else {
      //     console.log('No Data')
      //   }
      // })
    } else if (id.substring(0, 2) === "IM" && lde === "NoLDE") {
      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${"ItemMaster"}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      );
      window.open(
        `/Dynamic_Forms?token=ItemMaster&action=approval&orgId=${lde}&docId=${id}`,
        "_blank"
      );
      // postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${'ItemMaster'}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      // ).then(response => {
      //   if (response.res.status === 'success') {
      //     console.log(response.res.data)
      //     setSearchJSON(response.res.data)
      //     setRedirectIM(true)
      //   } else {
      //     console.log('No Data')
      //   }
      // })
    } else if (id.substring(0, 2) === "IP") {
      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${"InternalPlan"}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      );
      window.open(
        `/Dynamic_Forms?token=InternalPlan&action=approval&orgId=${lde}&docId=${id}`,
        "_blank"
      );
      // postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${'InternalPlan'}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      // ).then(response => {
      //   if (response.res.status === 'success') {
      //     console.log(response.res.data)
      //     setSearchJSON(response.res.data)
      //     setRedirectIP(true)
      //   } else {
      //     console.log('No Data')
      //   }
      // })
    } else if (id.substring(0, 2) === "OM") {
      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${"OrganizationMaster"}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      );
      window.open(
        `/Dynamic_Forms?token=OrganizationMaster&action=approval&orgId=${lde}&docId=${id}`,
        "_blank"
      );
      // postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${'OrganizationMaster'}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      // ).then(response => {
      //   if (response.res.status === 'success') {
      //     console.log(response.res.data)
      //     setSearchJSON(response.res.data)
      //     setRedirectOM(true)
      //   } else {
      //     console.log('No Data')
      //   }
      // })
    } else if (id.substring(0, 2) === "BN" || id.substring(0, 2) === "BE") {
      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${"BillExtract"}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      );
      window.open(
        `/Dynamic_Forms?token=BillExtract&action=approval&orgId=${lde}&docId=${id}`,
        "_blank"
      );
      // postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${'BillExtract'}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      // ).then(response => {
      //   if (response.res.status === 'success') {
      //     console.log(response.res.data)
      //     setSearchJSON(response.res.data)
      //     setRedirectBE(true)
      //   } else {
      //     console.log('No Data')
      //   }
      // })
    } else if (id.substring(0, 2) === "GS") {
      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${"GoodsAndServicesEntries"}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      );
      window.open(
        `/Dynamic_Forms?token=GoodsAndServicesEntries&action=approval&orgId=${lde}&docId=${id}`,
        "_blank"
      );
      // postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${'GoodsAndServicesEntries'}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      // ).then(response => {
      //   if (response.res.status === 'success') {
      //     console.log(response.res.data)
      //     setSearchJSON(response.res.data)
      //     setRedirectGS(true)
      //   } else {
      //     console.log('No Data')
      //   }
      // })
    } else if (id.substring(0, 2) === "VM" && lde !== "NoLDE") {
      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${"VendorPreferences"}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      );
      window.open(
        `/Dynamic_Forms?token=VendorPreferences&action=approval&orgId=${lde}&docId=${id}`,
        "_blank"
      );
      // console.log('Entered VendorPreference')
      // postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${'VendorPreferences'}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      // ).then(response => {
      //   if (response.res.status === 'success') {
      //     console.log(response.res.data)
      //     setSearchJSON(response.res.data)
      //     setRedirectVP(true)
      //   } else {
      //     console.log('No Data')
      //   }
      // })
    } else if (id.substring(0, 2) === "IM" && lde !== "NoLDE") {
      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${"ItemPreferences"}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      );
      window.open(
        `/Dynamic_Forms?token=ItemPreferences&action=approval&orgId=${lde}&docId=${id}`,
        "_blank"
      );
      // console.log('Entered ItemPreferences')
      // postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${'ItemPreferences'}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      // ).then(response => {
      //   if (response.res.status === 'success') {
      //     console.log(response.res.data)
      //     setSearchJSON(response.res.data)
      //     setRedirectItemPre(true)
      //   } else {
      //     console.log('No Data')
      //   }
      // })
    } else if (id.substring(0, 2) === "BR") {
      localStorage.setItem(
        "api",
        `api/edureka/approveJson?module=${localStorage.getItem(
          "module"
        )}&screenName=${"ItemPreferences"}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      );
      window.open(
        `/Dynamic_Forms?token=ItemPreferences&action=approval&orgId=${lde}&docId=${id}`,
        "_blank"
      );
      // postRequest(
      //   `api/edureka/approveJson?module=${localStorage.getItem(
      //     'module'
      //   )}&screenName=${'BudgetRelease'}&activitycode=${activityCode}&id=${id}&lde=${lde}`
      // ).then(response => {
      //   if (response.res.status === 'success') {
      //     console.log(response.res.data)
      //     setSearchJSON(response.res.data)
      //     setRedirectBudgetRelease(true)
      //   } else {
      //     console.log('No Data')
      //   }
      // })
    }
  };

  const fetchTableData = () => {
    if (formData.orgname) {
      const id = companyDetails.filter(
        (item) => item.orgname === formData.orgname
      );
      const companyid = id.map((item) => item.orgid);

      setFetching(true);
      setLoading(true);
      setShowtable(false);

      setTimeout(() => {
        getRequest(
          `api/edureka/getVendorApproval?status=${formData.task}&orgid=${companyid[0]}`
        )
          .then((res) => {
            const value = res.res.data;
            const tempArrID = value.map((obj) => obj["Vendor ID"]);
            const filtedID = [...new Set(tempArrID)]
              .map((obj) => obj ?? null)
              .filter((name) => name && name.trim() !== "");
            const tempArrType = value.map((obj) => obj["Type"]);
            const filtedType = [...new Set(tempArrType)]
              .map((obj) => obj ?? null)
              .filter((name) => name && name.trim() !== "");
            const tempArrName = value.map((obj) => obj["Vendor Name"]);
            const filteredName = [...new Set(tempArrName)];
            const finalName = filteredName
              .map((obj) => obj ?? null)
              .filter((name) => name && name.trim() !== "");
            const tempActivityCode = value.map((obj) => obj["activitycode"]);
            const filtedActivitycode = [...new Set(tempActivityCode)]
              .map((obj) => obj ?? null)
              .filter((name) => name && name.trim() !== "");

            setTableData(res.res.data);
            setFilterData(res.res.data);
            setDropdown_id(filtedID);
            setDropdown_number(finalName);
            setDropdown_type(filtedType);
            setDropdown_activitycode(filtedActivitycode);
            setShowtable(true);
            setFetching(false);
            setLoading(false);
          })
          .catch((err) => console.log(err));
      }, 5000);
    }
  };

  const onBack = (input) => {
    switch (input) {
      case "redirectVM":
        setRedirectVM(false);
        break;
      case "redirectPO":
        setRedirectPO(false);
        break;
      case "redirectIM":
        setRedirectIM(false);
        break;
      case "redirectIP":
        setRedirectIP(false);
        break;
      case "redirectOM":
        setRedirectOM(false);
        break;
      case "redirectBE":
        setRedirectBE(false);
        break;
      case "redirectGS":
        setRedirectGS(false);
        break;
      case "redirectVP":
        setRedirectVP(false);
        break;
      case "redirectItemPre":
        setRedirectItemPre(false);
        break;
      case "redirectBudgetRelease":
        setRedirectBudgetRelease(false);
        break;
    }
    setSearchJSON([]);
    fetchTableData();
  };

  const handleDropdownID = (id) => {
    if (id !== "" && id !== null) {
      setFilterData(tableData.filter((obj) => obj["Vendor ID"] === id));
      setSearchFormData({
        documentName: "",
        documentType: "",
        documentActivityCode: "",
        documentID: id,
      });
    } else {
      setFilterData(tableData);
      setSearchFormData({
        documentID: "",
        documentName: "",
        documentType: "",
        documentActivityCode: "",
      });
    }
  };

  const handleDropdownName = (name) => {
    if (name !== "" && name !== null) {
      setFilterData(tableData.filter((obj) => obj["Vendor Name"] === name));
      setSearchFormData({
        documentID: "",
        documentType: "",
        documentActivityCode: "",
        documentName: name,
      });
    } else {
      setFilterData(tableData);
      setSearchFormData({
        documentID: "",
        documentName: "",
        documentType: "",
        documentActivityCode: "",
      });
    }
  };

  const handleDropdownType = (type) => {
    if (type !== "" && type !== null) {
      setFilterData(tableData.filter((obj) => obj["Type"] === type));
      setSearchFormData({
        documentID: "",
        documentName: "",
        documentActivityCode: "",
        documentType: type,
      });
    } else {
      setFilterData(tableData);
      setSearchFormData({
        documentID: "",
        documentName: "",
        documentType: "",
        documentActivityCode: "",
      });
    }
  };

  const handleDropdownActivityCode = (activityCode) => {
    if (activityCode !== "" && activityCode !== null) {
      setFilterData(
        tableData.filter((obj) => obj["activitycode"] === activityCode)
      );
      setSearchFormData({
        documentID: "",
        documentName: "",
        documentType: "",
        documentActivityCode: activityCode,
      });
    } else {
      setFilterData(tableData);
      setSearchFormData({
        documentID: "",
        documentName: "",
        documentType: "",
        documentActivityCode: "",
      });
    }
  };

  const handleCompanyChange = (val) => {
    setShowtable(false);
    setFormData((prev) => ({
      ...prev,
      task: "",
      orgname: val,
    }));
  };

  if (redirectVM) {
    return (
      <VR2_Forms
        screenName={"VendorMaster"}
        screenAction={"approval"}
        From_SearchJSON={SearchJSON}
        onBack={() => onBack("redirectVM")}
      />
    );
  }

  if (redirectPO) {
    return (
      <VR2_Forms
        screenName={"PurchaseOrder"}
        screenAction={"approval"}
        From_SearchJSON={SearchJSON}
        onBack={() => onBack("redirectPO")}
      />
    );
  }

  if (redirectIM) {
    return (
      <VR2_Forms
        screenName={"ItemMaster"}
        screenAction={"approval"}
        From_SearchJSON={SearchJSON}
        onBack={() => onBack("redirectIM")}
      />
    );
  }

  if (redirectIP) {
    return (
      <VR2_Forms
        screenName={"InternalPlan"}
        screenAction={"approval"}
        From_SearchJSON={SearchJSON}
        onBack={() => onBack("redirectIP")}
      />
    );
  }

  if (redirectOM) {
    return (
      <VR2_Forms
        screenName={"OrganizationMaster"}
        screenAction={"approval"}
        From_SearchJSON={SearchJSON}
        onBack={() => onBack("redirectOM")}
      />
    );
  }

  if (redirectBE) {
    return (
      <VR2_Forms
        screenName={"BillExtract"}
        screenAction={"approval"}
        From_SearchJSON={SearchJSON}
        onBack={() => onBack("redirectBE")}
      />
    );
  }

  if (redirectGS) {
    return (
      <VR2_Forms
        screenName={"GoodsAndServicesEntries"}
        screenAction={"approval"}
        From_SearchJSON={SearchJSON}
        onBack={() => onBack("redirectGS")}
      />
    );
  }

  if (redirectVP) {
    return (
      <VR2_Forms
        screenName={"VendorPreferences"}
        screenAction={"approval"}
        From_SearchJSON={SearchJSON}
        onBack={() => onBack("redirectVP")}
      />
    );
  }

  if (redirectItemPre) {
    return (
      <VR2_Forms
        screenName={"ItemPreferences"}
        screenAction={"approval"}
        From_SearchJSON={SearchJSON}
        onBack={() => onBack("redirectItemPre")}
      />
    );
  }

  if (redirectBudgetRelease) {
    return (
      <VR2_Forms
        screenName={"BudgetRelease"}
        screenAction={"approval"}
        From_SearchJSON={SearchJSON}
        onBack={() => onBack("redirectBudgetRelease")}
      />
    );
  }

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Document Approvals</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                options={dropdown_orgname || []}
                value={formData.orgname || ""}
                onChange={(e, newValue) => handleCompanyChange(newValue)}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Company Name"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete
                options={["Approved", "Waiting For Approval", "Rejected"]}
                value={formData.task || ""}
                onChange={(e, newValue) => handleChange(newValue)}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="What Approvals Do You Want To See?"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>
          </Grid>
          {showtable && tableData.length > 0 && (
            <>
              <Typography variant="h6" mt={2} mb={2}>
                Filter{" "}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    options={dropdown_id || []}
                    value={searchFormData.documentID || ""}
                    onChange={(e, newValue) => handleDropdownID(newValue)}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select By ID"
                        variant="outlined"
                        size="small"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    options={dropdown_number || []}
                    value={searchFormData.documentName || ""}
                    onChange={(e, newValue) => handleDropdownName(newValue)}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select By Name"
                        variant="outlined"
                        size="small"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    options={dropdown_type || []}
                    value={searchFormData.documentType || ""}
                    onChange={(e, newValue) => handleDropdownType(newValue)}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select By Type"
                        variant="outlined"
                        size="small"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={3}>
                  <Autocomplete
                    options={dropdown_activitycode || []}
                    value={searchFormData.documentActivityCode || ""}
                    onChange={(e, newValue) =>
                      handleDropdownActivityCode(newValue)
                    }
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select By Activity Code"
                        variant="outlined"
                        size="small"
                      />
                    )}
                  />
                </Grid>
              </Grid>{" "}
            </>
          )}
        </AccordionDetails>
      </Accordion>
      {tableData.length > 0 && (
        <Box
          align="right"
          sx={{
            m: 2,
            display: "flex",
            justifyContent: "flex-end",
            flexDirection: "row",
            gap: 2,
          }}
        >
          <>
            <Pagination
              count={Math.ceil(filterData.length / rowsPerPage)}
              page={page + 1}
              onChange={(event, newPage) => {
                handleChangePage(event, newPage - 1);
              }}
              variant="outlined"
              shape="rounded"
              showFirstButton
              showLastButton
            />
            &nbsp;
            <CSVLink
              size="sm"
              filename={`Approvals_${moment().format(
                "YYYY-MM-DD_HH-mm-ss"
              )}.csv`}
              data={tableData}
            >
              <Button variant="contained" color="success">
                <GetAppIcon />
              </Button>
            </CSVLink>
          </>
        </Box>
      )}
      {showtable && tableData.length > 0 ? (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    pl: 1,
                    pt: 1,
                    pb: 1,
                    pr: 1,
                    whiteSpace: "balance",
                    minWidth: "200px",
                  }}
                >
                  Document ID
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    pt: 1,
                    pb: 1,
                    pr: 1,
                    whiteSpace: "balance",
                    minWidth: "200px",
                  }}
                >
                  Organization ID
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    pt: 1,
                    pb: 1,
                    pr: 1,
                    whiteSpace: "balance",
                    minWidth: "200px",
                  }}
                >
                  Type
                </TableCell>
                <TableCell
                  sx={{ pl: 1, pt: 1, pb: 1, pr: 1, whiteSpace: "nowrap" }}
                >
                  LOB
                </TableCell>
                <TableCell
                  sx={{ pl: 1, pt: 1, pb: 1, pr: 1, whiteSpace: "nowrap" }}
                >
                  Function
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    pt: 1,
                    pb: 1,
                    pr: 1,
                    whiteSpace: "nowrap",
                    minWidth: "200px",
                  }}
                >
                  Vendor Name
                </TableCell>
                <TableCell
                  sx={{ pl: 1, pt: 1, pb: 1, pr: 1, whiteSpace: "nowrap" }}
                >
                  Activity Type
                </TableCell>
                <TableCell
                  sx={{ pl: 1, pt: 1, pb: 1, pr: 1, whiteSpace: "nowrap" }}
                >
                  Activity Code
                </TableCell>
                <TableCell
                  sx={{ pl: 1, pt: 1, pb: 1, pr: 1, whiteSpace: "nowrap" }}
                >
                  Activity Name
                </TableCell>
                <TableCell
                  sx={{ pl: 1, pt: 1, pb: 1, pr: 1, whiteSpace: "nowrap" }}
                >
                  Process Code
                </TableCell>
                <TableCell
                  sx={{ pl: 1, pt: 1, pb: 1, pr: 1, whiteSpace: "nowrap" }}
                >
                  Process Name
                </TableCell>
                <TableCell
                  sx={{ pl: 1, pt: 1, pb: 1, pr: 1, whiteSpace: "nowrap" }}
                >
                  In Period From
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(filterData.length > 0 &&
                (rowsPerPage > 0
                  ? filterData.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  : filterData
                ).map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Button variant="text" onClick={() => handleID(item)}>
                          {item["Vendor ID"]}
                        </Button>
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Button variant="text" onClick={() => handleID(item)}>
                          {item["organizationid"]}
                        </Button>
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "balance",
                        }}
                      >
                        {item["Type"]}
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.lob}
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item["Department"]}
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "balance",
                        }}
                      >
                        {item["Vendor Name"]}
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.activitytype}
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.activitycode}
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.activityname}
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.processcode}
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.processname}
                      </TableCell>
                      <TableCell
                        sx={{
                          pl: 1,
                          pt: 1,
                          pb: 1,
                          pr: 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.inprdfrom}
                      </TableCell>
                    </TableRow>
                  );
                })) || (
                  <TableRow>
                    <TableCell
                      colSpan={Object.keys(filterData[0])?.length}
                      sx={{ p: 5 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                      >
                        <Alert severity="error" variant="outlined">
                          No matching records found. Please adjust your search
                          criteria.
                        </Alert>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}

      {filterData.length === 0 && !fetching ? (
        <div className="center-screen">
          <h5>No Data Found</h5>
        </div>
      ) : null}
    </>
  );
};

export default Approval;